import PropTypes from 'prop-types';
import React from 'react';
import Notifications, { NotificationsState } from 'react-notification-system-redux';
import { connect } from 'react-redux';
// import { config } from '../../../../prime/common';

export interface DrawerProps {
    notificationState: NotificationsState;
}

class Drawer extends React.Component<DrawerProps> {
    public static propTypes = {
        notificationState: PropTypes.any,
    };
    public style: any;

    constructor(props: DrawerProps) {
        super(props);

        this.style = {
            NotificationItem: { // Override the notification item
                DefaultStyle: { // Applied to every notification, regardless of the notification level
                    fontFamily: 'Roboto, sans-serif',
                    fontSize: 14,
                },
            },
        };
    }

    public render() {
        const { notificationState } = this.props;

        // Optional styling
        const style = {
            NotificationItem: { // Override the notification item
                DefaultStyle: { // Applied to every notification, regardless of the notification level
                    margin: '100px 5px 2px 1px',
                },

                success: { // Applied only to the success notification item
                    // color: 'blue',
                },
            },
        };

        // iframe Fix
        // if (config.UseIFrameLogic) {
        //    const w: any = window;
        //    if (w.parentIFrame) {
        //        w.parentIFrame.scrollTo(0, 0);
        //    }
        // }

        return (
          <Notifications notifications={notificationState} style={style} />
        );
    }
}

export default connect(
    (store: { notificationState: NotificationsState }) => ({ notificationState: store.notificationState }),
)(Drawer);
